<template>
    <div>
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex lg4 pr-6 pl-6>
                    <v-layout row wrap justify-end>
                        <v-menu v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y
                            max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="computedStartDateFormatted" label="Từ ngày" hint="DD-MM-YYYY"
                                    persistent-hint prepend-icon="fa-calendar-alt" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title
                                @input="menuStart = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y
                            max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="computedEndDateFormatted" label="Đến ngày" hint="DD-MM-YYYY"
                                    persistent-hint prepend-icon="fa-calendar-alt" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 pr-6>
                    <v-btn @click="filter_data" color="#3480c1" outlined>Xem</v-btn>
                </v-flex>
                <v-flex lg12 v-if="items">
                    <v-data-table :headers="headers" :items="items" :server-items-length="items.length" :loading="loading">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ storeDisplay(item.ReceivePlaceID) }}</td>
                                <td>{{ item.OrderType == 1 ? 'Mua hộ' : 'Ký gửi' }}</td>
                                <td class="text-end">{{ item.TotalOrder | currency }}</td>
                                <td class="text-end">{{ item.TotalAmount | currency }}</td>
                                <td class="text-end">{{ item.TotalFeeWeight | currency }}</td>
                                <td class="text-end">{{ item.TotalFragileFee | currency }}</td>
                                <td class="text-end">{{ item.TotalCheckFee | currency }}</td>
                                <td class="text-end">{{ item.TotalGuaranteeFee | currency }}</td>
                                <td class="text-end">{{ item.TotalBuyFee | currency }}</td>
                            </tr>
                        </template>
                        <template v-slot:body.append v-if="summary">
                            <tr>
                                <td class="font-weight-bold" colspan="2">TỔNG</td>
                                <td class="text-end font-weight-bold">{{ summary.TotalOrder | currency }}
                                    <p class="md-line">Mua hộ: {{ summary_md.TotalOrder | currency }}</p>
                                    <p class="kg-line">Ký gửi: {{ summary_kg.TotalOrder | currency }}</p>
                                </td>
                                <td class="text-end font-weight-bold">{{ summary.TotalAmount | currency }}
                                    <p class="md-line">Mua hộ: {{ summary_md.TotalAmount | currency }}</p>
                                    <p class="kg-line">Ký gửi: {{ summary_kg.TotalAmount | currency }}</p>
                                </td>
                                <td class="text-end font-weight-bold">{{ summary.TotalFeeWeight | currency }}
                                    <p class="md-line">Mua hộ: {{ summary_md.TotalFeeWeight | currency }}</p>
                                    <p class="kg-line">Ký gửi: {{ summary_kg.TotalFeeWeight | currency }}</p>
                                </td>
                                <td class="text-end font-weight-bold">{{ summary.TotalFragileFee | currency }}
                                    <p class="md-line">Mua hộ: {{ summary_md.TotalFragileFee | currency }}</p>
                                    <p class="kg-line">Ký gửi: {{ summary_kg.TotalFragileFee | currency }}</p>
                                </td>
                                <td class="text-end font-weight-bold">{{ summary.TotalCheckFee | currency }}
                                    <p class="md-line">Mua hộ: {{ summary_md.TotalCheckFee | currency }}</p>
                                    <p class="kg-line">Ký gửi: {{ summary_kg.TotalCheckFee | currency }}</p>
                                </td>
                                <td class="text-end font-weight-bold">{{ summary.TotalGuaranteeFee | currency }}
                                    <p class="md-line">Mua hộ: {{ summary_md.TotalGuaranteeFee | currency }}</p>
                                    <p class="kg-line">Ký gửi: {{ summary_kg.TotalGuaranteeFee | currency }}</p>
                                </td>
                                <td class="text-end font-weight-bold">{{ summary.TotalBuyFee | currency }}
                                    <p class="md-line">Mua hộ: {{ summary_md.TotalBuyFee | currency }}</p>
                                    <p class="kg-line">Ký gửi: {{ summary_kg.TotalBuyFee | currency }}</p>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment"
export default {
    data() {
        return {
            viewName: "thong-ke-doanh-thu-kho",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            headers: [
                {
                    text: "Kho VN",
                    value: "ReceivePlaceID",
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Loại đơn",
                    value: "OrderType",
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Số đơn",
                    value: "TotalOrder",
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Doanh số",
                    value: "TotalAmount",
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phí vận chuyển",
                    value: "TotalFeeWeight",
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phí đóng gỗ",
                    value: "TotalFragileFee",
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phí kiểm hàng",
                    value: "TotalCheckFee",
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phí bảo hiểm",
                    value: "TotalGuaranteeFee",
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phí mua hàng",
                    value: "TotalBuyFee",
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                }
            ]
        };
    },
    computed: {
        ...mapState({
            items: state => state.analytic.realtime_storage,
            loading: state => state.analytic.loading,
            stores: (state) => state.commons.stores,
        }),
        summary() {
            var ret = {
                'TotalOrder': _.sumBy(this.items, 'TotalOrder'),
                'TotalAmount': _.sumBy(this.items, 'TotalAmount'),
                'TotalFeeWeight': _.sumBy(this.items, 'TotalFeeWeight'),
                'TotalFragileFee': _.sumBy(this.items, 'TotalFragileFee'),
                'TotalCheckFee': _.sumBy(this.items, 'TotalCheckFee'),
                'TotalGuaranteeFee': _.sumBy(this.items, 'TotalGuaranteeFee'),
                'TotalBuyFee': _.sumBy(this.items, 'TotalBuyFee'),
            };
            return ret;
        },
        summary_md() {
            let md = _.filter(this.items, {'OrderType': 1});
            var ret = {
                'TotalOrder': _.sumBy(md, 'TotalOrder'),
                'TotalAmount': _.sumBy(md, 'TotalAmount'),
                'TotalFeeWeight': _.sumBy(md, 'TotalFeeWeight'),
                'TotalFragileFee': _.sumBy(md, 'TotalFragileFee'),
                'TotalCheckFee': _.sumBy(md, 'TotalCheckFee'),
                'TotalGuaranteeFee': _.sumBy(md, 'TotalGuaranteeFee'),
                'TotalBuyFee': _.sumBy(md, 'TotalBuyFee'),
            };
            return ret;
        },
        summary_kg() {
            let kg = _.filter(this.items, {'OrderType': 2});
            var ret = {
                'TotalOrder': _.sumBy(kg, 'TotalOrder'),
                'TotalAmount': _.sumBy(kg, 'TotalAmount'),
                'TotalFeeWeight': _.sumBy(kg, 'TotalFeeWeight'),
                'TotalFragileFee': _.sumBy(kg, 'TotalFragileFee'),
                'TotalCheckFee': _.sumBy(kg, 'TotalCheckFee'),
                'TotalGuaranteeFee': _.sumBy(kg, 'TotalGuaranteeFee'),
                'TotalBuyFee': _.sumBy(kg, 'TotalBuyFee'),
            };
            return ret;
        },
        computedStartDateFormatted() {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted() {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT)
            };
            this.$store.dispatch("analytic/getRealtimeStorage", param);
        },
        storeDisplay(value) {
            const store = _.find(this.stores, { ID: value });
            return store ? store.Name : "";
        },
    },
    mounted() {
        this.$store.dispatch("commons/getAllStores");
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>
<style type="text/css" scoped>
.md-line, .kg-line {
    margin: 0;
    font-size: 12px;
}
.md-line {
    color: rgb(50, 50, 233);
}
.kg-line {
    color: rgb(77, 134, 2);
}
</style>